import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { motion } from "framer-motion";
import { name } from '../constants';
import Background from './Background';
import Footer from './Footer';

const Home = () => {

	const ref = useRef(0);
	const [text, setText] = useState('');

	useEffect(() => {
		const interval = setInterval(() => {
			if (ref.current < name.length) {
				ref.current++;
				setText(() => text + name[ref.current - 1]);
			}
		}, 500);
		return () => clearInterval(interval);
	}, [text]);

	return (
		<div className='area relative z-0 bg-black w-screen h-screen'>
			<ul class="circles">
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
			</ul>
			<div className='hero relative h-[calc(100vh)] flex justify-center items-center text-white' id='hero'>
				<motion.div 
					className='pt-4 h-36 backdrop-blur-sm rounded-3xl'
					initial={{ opacity: 0, y: 50 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, ease: "easeOut" }}
				>
					<motion.h1 
						className='text-6xl sm:text-7xl font-extrabold mt-2'
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.6, delay: 0.2 }}
					>
						Hi, I'm&nbsp;<span className='text-yellow-200 font-extrabold'>{text}</span>
					</motion.h1>
					<motion.p 
						className='mt-3 text-xl'
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.6, delay: 0.4 }}
					>
						I love to learn and build optimised software and test them.
					</motion.p>
				</motion.div>      
			</div>
			<Footer/>
		</div>	
	);
}

export default Home;